*,
:host {
    box-sizing: border-box;
}

:host {
    display: block;
    --primary-color: var(--color-layout-base);
    --secondary-color: var(--color-layout-contrast);
    --tertiary-color: var(--color-layout-shade-60);
}

:host([variant='highlight']) {
    --primary-color: var(--color-layout-highlight);
    --secondary-color: var(--color-layout-contrast);
    --tertiary-color: var(--color-layout-contrast);
}

.header_button {
    --spacing: 10px;

    &.circle {
        --spacing: 6px;
    }

    &[disabled] {
        --background-color: var(--primary-color);
        --foreground-color: var(--color-layout-shade-30);
        --border-color: var(--color-layout-shade-30);

        &[high-contrast] {
            --foreground-color: var(--color-layout-contrast);
        }
    }
}

.caret {
    transition: transform 300ms ease;
    transform: rotate(0deg);

    &.open {
        transform: rotate(180deg);
    }
}

.inner {
    border-radius: 0px;
    opacity: 0;
    transition: opacity 400ms ease;
    background-color: var(--color-layout-shade-10);
    border-style: solid;
    border-color: var(--color-layout-contrast);
    border-width: 2px 0px;
    box-shadow: none;
    position: relative;

    &.high-contrast {
        border-width: 2px 1px;
    }

    &.entered {
        opacity: 1;
    }
}

.arrow::after {
    background-color: var(--color-layout-contrast);
}

.open {
    --background-color: var(--secondary-color);
    --foreground-color: var(--primary-color);
    --border-color: var(--primary-color);
}

es-layout-button,
es-layout-link {
    --blob-size: 24px;
    --default-color: var(--color-layout-contrast);
    --active-color: var(--color-layout-highlight);
    --disabled-color: var(--color-layout-shade-50);
    --active-background-color: var(--color-layout-shade-20);

    &::part(link) {
        outline-offset: -3px;
    }
}

es-layout-section {
    margin-bottom: 6px;

    &::part(header) {
        color: var(--color-layout-contrast);
        padding: 16px 20px;
    }

    &::part(title) {
        font-size: 18px;
        font-weight: 300;
    }
}
